export function isParticularsPage(steps: Array<any>, stepIdx: number) {
    if (stepIdx > steps.length - 1) return false;
    if (
        steps[stepIdx]?.stepId.toLowerCase().includes('particular') ||
        steps[stepIdx]?.stepId.toLowerCase().includes('part_a_info_requested') //COAP STEPID
    ) {
        return true;
    }
    return false;
}
